import {
  AttendanceCustomTimeRangeDayEnum,
  AttendanceCustomTimeRangeDayEnum as DayEnum,
} from 'generated/resources/graphql'

import { CustomTimeRange } from '../useFetchCustomTimeRanges'

export enum ActionTypes {
  OPEN_BASE_CREATE_TIME_RANGE = 'OPEN_BASE_CREATE_TIME_RANGE',
  OPEN_CUSTOM_CREATE_TIME_RANGE = 'OPEN_CUSTOM_CREATE_TIME_RANGE',
  OPEN_BASE_EDIT_TIME_RANGE = 'OPEN_BASE_EDIT_TIME_RANGE',
  OPEN_CUSTOM_EDIT_TIME_RANGE = 'OPEN_CUSTOM_EDIT_TIME_RANGE',
  OPEN_BASE_DELETE_TIME_RANGE = 'OPEN_BASE_DELETE_TIME_RANGE',
  OPEN_CUSTOM_DELETE_TIME_RANGE = 'OPEN_CUSTOM_DELETE_TIME_RANGE',
  CLEAR = 'CLEAR',
}

export enum CustomTimeRangeAction {
  createOpen = 'create_open',
  editOpen = 'edit_open',
  deleteOpen = 'delete_open',
}

export enum Layout {
  base = 'base',
  custom = 'custom',
}

export interface Action {
  type: string
  customTimeRanges?: CustomTimeRange[]
  timeRangeIds?: number[]
  dayType?: AttendanceCustomTimeRangeDayEnum
}

export interface State {
  layout: string
  action: string
  regularCustomTimeRange?: CustomTimeRange
  overtimeCustomTimeRange?: CustomTimeRange
  timeRangeIds?: number[]
  dayType?: AttendanceCustomTimeRangeDayEnum
  customTimeRangeDispatch: React.Dispatch<Action>
  dayEnums: DayEnum[]
}

const initialState: State = {
  action: 'close',
  layout: Layout.base,
  regularCustomTimeRange: undefined,
  overtimeCustomTimeRange: undefined,
  timeRangeIds: [],
  dayType: 'monday',
  dayEnums: [],
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  customTimeRangeDispatch: () => {},
}

export type Dispatch = (arg0: Action) => void

const reducer = (state: State, action: Action): State => {
  const { type, customTimeRanges, timeRangeIds, dayType } = action
  switch (type) {
    case ActionTypes.OPEN_BASE_CREATE_TIME_RANGE:
      return {
        ...state,
        layout: Layout.base,
        action: CustomTimeRangeAction.createOpen,
        ...(dayType && { dayType: dayType }),
      }
    case ActionTypes.OPEN_CUSTOM_CREATE_TIME_RANGE:
      return {
        ...state,
        layout: Layout.custom,
        action: CustomTimeRangeAction.createOpen,
        ...(dayType && { dayType: dayType }),
      }
    case ActionTypes.OPEN_BASE_EDIT_TIME_RANGE:
      return {
        ...state,
        layout: Layout.base,
        action: CustomTimeRangeAction.editOpen,
        ...(customTimeRanges && {
          regularCustomTimeRange: customTimeRanges.find(
            (timeRange) => timeRange.timeType === 'regular'
          ),
          overtimeCustomTimeRange: customTimeRanges.find(
            (timeRange) => timeRange.timeType === 'overtime'
          ),
        }),
      }
    case ActionTypes.OPEN_CUSTOM_EDIT_TIME_RANGE:
      return {
        ...state,
        layout: Layout.custom,
        action: CustomTimeRangeAction.editOpen,
        ...(customTimeRanges && {
          regularCustomTimeRange: customTimeRanges.find(
            (timeRange) => timeRange.timeType === 'regular'
          ),
          overtimeCustomTimeRange: customTimeRanges.find(
            (timeRange) => timeRange.timeType === 'overtime'
          ),
        }),
      }

    case ActionTypes.OPEN_BASE_DELETE_TIME_RANGE:
      return {
        ...state,
        layout: Layout.base,
        action: CustomTimeRangeAction.deleteOpen,
        timeRangeIds: timeRangeIds || [],
        dayType: dayType,
      }

    case ActionTypes.OPEN_CUSTOM_DELETE_TIME_RANGE:
      return {
        ...state,
        layout: Layout.custom,
        action: CustomTimeRangeAction.deleteOpen,
        timeRangeIds: timeRangeIds || [],
      }

    case ActionTypes.CLEAR:
      return { ...state, layout: '', action: '', dayType: 'monday' }
    default:
      return initialState
  }
}

export { reducer, initialState }
